import { render, staticRenderFns } from "./TreatmentCategoriesList.vue?vue&type=template&id=0833bee1&"
import script from "./TreatmentCategoriesList.vue?vue&type=script&lang=js&"
export * from "./TreatmentCategoriesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports